import { MockService } from '../../../core/services/mock.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable, map, of, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Option } from 'src/app/base/models/option.model';
import { UserRole } from '../models/account.model';
import { Role } from '../enums/role.enum';

@Injectable({
  providedIn: 'root',
})
export class AccountService {

  private brands: Option[] = [];
  private _currentRole$ = new BehaviorSubject<Role[]>([]);

  
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 500;

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) {}

  /**
   * 因為 Brand 清單不會頻繁改變，所以透過 brands 變數保存資料。
   * 如果取到值了，之後都用這個值直接回傳，不用每次都重新查詢。
   *
   * @param keyword Brand 查詢關鍵字，不傳就是查全部
   */
  getBrands(keyword?: string): Observable<Option[]> {
    // 如果已經有儲存的所有 Brand 就從裡面篩選
    if (this.brands && this.brands.length > 0) {
      const filteredBrands = this.brands.filter(brand =>
        keyword ? brand.label.toLowerCase().includes(keyword.toLowerCase()) : true
      );
      return of(filteredBrands);
    }
    let endpoint = `${environment.accountApiEndpoint}/datapermission/brands`;
    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/datapermission/brands.json');
    return this.httpClient.get<{ name: string }[]>(endpoint).pipe(
      map(response => {
        this.brands = response.map(brandResponse => ({
          id: brandResponse.name,
          value: brandResponse.name,
          label: brandResponse.name
        }));

        return this.brands.filter(brand =>
          keyword ? brand.label.toLowerCase().includes(keyword.toLowerCase()) : true
        );
      })
    );
  }

  get currentRole$() {
    return this._currentRole$.asObservable();
  }

  setCurrentRole(): Observable<Role[] | undefined> {
    // 如果已有角色，直接回傳快取的 observable（不呼叫API）
    if (this._currentRole$.value.length > 0) {
      return of(this._currentRole$.value);
    }

    // 否則呼叫 API 取得角色
    let endpoint = `${environment.accountApiEndpoint}/datapermission/roles`;

    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/datapermission/roles.json');
    return this.httpClient.get<UserRole>(endpoint).pipe(
      map(response => {
        const enumRole = response.userRoles
        .map(role => this.stringToEnum(Role, role))
        .filter(role => role !== undefined) as Role[];
        
        this._currentRole$.next(enumRole);
        return this._currentRole$.value;
      })
    );
  }
  
  private stringToEnum<T extends { [key: string]: string | number }>(enumObj: T, value: string): T[keyof T] | undefined {
    const enumValues = Object.values(enumObj);
    return enumValues.includes(value as any) ? (value as T[keyof T]) : undefined;
  }
}
